export class InventoryCurrentBalanceContainerModel {
  bl_inv_current_location_stock_balance: bl_inv_current_location_stock_balance;
}

export class bl_inv_current_location_stock_balance {
  guid: string;
  namespace: string;
  module_guid: string;
  applet_guid: string;
  obj_code: string;
  obj_type: string;
  comp_guid: string;
  location_guid: string;
  inv_item_guid: string;
  inv_item_code: string;
  fi_item_guid: string;
  fi_item_code: string;
  sub_location_code: string;
  serial_no_json: any;
  batch_no_json: any;
  qty_ledger: number;
  qty_physical: number;
  qty_available: number;
  qty_reserved: number;
  qty_display_unit: number;
  qty_damaged: number;
  qty_rma: number;
  qty_ecom_buffer: number;
  qty_sales_order_open: number;
  qty_purchase_order_open: number;
  qty_work_order_open: number;
  qty_jobsheet_open: number;
  qty_reorder_level: number;
  qty_min_level: number;
  qty_max_level: number;
  cost_ma_amount: number;
  cost_ma_price: number;
  cost_wa_amount: number;
  cost_wa_price: number;
  cost_fifo_amount: number;
  cost_fifo_price: number;
  cost_lifo_amount: number;
  cost_lifo_price: number;
  cost_manual_amount: number;
  cost_manual_price: number;
  cost_replacement_amount: number;
  cost_replacement_price: number;
  cost_last_purchase_location: number;
  cost_last_purchase_company: number;
  acl_config: any;
  acl_policy: any;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  created_date: string;
  updated_date: string;
  status: string;
  revision: string;
  vrsn: string;
}
